<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items"
					:footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search"
					class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td style="cursor: pointer;">
								{{ row.item.loanModel.title }}
								<div class="grey--text">شماره وام: {{ row.item.code }}</div>
							</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td style="cursor: pointer;">
								{{ row.item.memberModel.fullName }}
								<div class="grey--text">کد ملی: {{ row.item.memberModel.nationalCode }}</div>
							</td>
							<td class="text-center">
								{{ row.item.subAgentModel.businessName }}
							</td>
							<td class="text-center">
								{{ row.item.subAgentDueDate_Persian.date }}
							</td>
							<td class="text-center">
								{{ row.item.subAgentPrice.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								<div class="info--text" style="cursor: pointer;" @click="transactionList(row.item)">{{
									row.item.sumSponsorPayments.toString().toPriceFormat() }}</div>
								<div @click="edit(row.item)">
									<small class="secondary--text" style="cursor: pointer;">
										ثبت واریزی
									</small>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
			left: 0;
			right: 0;
			font-size: 22px;
			background-color: rebeccapurple;
			color: #fff;
			justify-content: end;
			flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				مجموع: {{ sum.toString().toPriceFormat() }} تومان
			</div>
		</div>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-transaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>


	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'AgentOverDue',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'modify-transaction': () => import('@/views/admin/ModifyTransaction'),
		},
		data() {
			return {
				selectedTransaction: null,
				dialogTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				sum: 0,
				headers: [
					{
						text: 'مشخصات وام',
						align: 'start',
						sortable: true,
						value: 'loanModel.title',
					}, {
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'مشخصات مشتری',
						align: 'start',
						sortable: true,
						value: 'memberModel.fullName',
					}, {
						text: 'کد ملی',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.nationalCode',
					}, {
						text: 'نماینده',
						align: 'center',
						sortable: true,
						value: 'subAgentModel.businessName',
					}, {
						text: 'سررسید واریز نماینده',
						align: 'center',
						sortable: true,
						value: 'subAgentDueDate_Persian',
						excel_value: 'subAgentDueDate_Persian.date',
					}, {
						text: 'سهم نماینده',
						align: 'center',
						sortable: true,
						value: 'subAgentPrice',
						width: 200
					}, {
						text: 'مجموع واریز شما به نماینده',
						align: 'center',
						sortable: false,
						value: 'sumSponsorPayments'
					}
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست سررسید های زیرمجموعه ها'
				// if (this.startDate)
				// 	name += ' از ' + this.startDate.toString().split('T')[0]
				// if (this.endDate)
				// 	name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/UserLoan/SubAgentsOverDueList', {})
					.then(
						response => {
							this.items = response
							if (response.length)
								this.sum = response.map(x => x.subAgentPrice).reduce((prev, next) => {
									return prev + next
								})
							else
								this.sum = 0
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			edit(item) {
				this.selectedTransaction = { id: emptyId, paymentMethod: 2, isWithdraw: true, agent: { id: item.agentModel.id, businessName: item.agentModel.businessName, mobile: item.agentModel.mobile, firstName: item.agentModel.firstName, bankAccountsJson: item.agentModel.bankAccountsJson }, userLoan: { id: item.id, title: `شماره وام: ${item.code}, عنوان: ${item.loanModel.title}`, code: item.code }, amount: Math.max(item.agentPrice - item.sumSponsorPayments, 0), maxAmount: item.agentPrice - item.sumSponsorPayments }
				this.dialogTransaction = true
			},
			callbck_transaction(result) {
				this.dialogTransaction = false
				if (result)
					this.loadData()
			},
		},
	}
</script>
<style></style>
